// React Imports
import { useEffect, useState } from 'react'

// MUI Imports
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import { Button, CircularProgress } from '@mui/material'
import { saveSettingsRequest } from '../../../redux/settings/settingsSlice'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'


const TermsConditions = () => {
    const [onlineTC, setOnlineTC] = useState('')
    const [offlineTC, setOfflineTC] = useState('')
    const [errors, setErrors] = useState({ onlineTC: '', offlineTC: '' })
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const productTerms = useSelector(
        (state) => state.productlist?.productTermsAndConditions,
        shallowEqual,
    )

    useEffect(() => {
        if (productTerms) {
            setOnlineTC(productTerms.tconline ?? '')
            setOfflineTC(productTerms.tcoffline ?? '')
        }
    }, [productTerms])

    const validate = () => {
        const newErrors = { onlineTC: '', offlineTC: '' }
        let isValid = true

        if (!onlineTC.trim() && !offlineTC.trim()) {
            newErrors.onlineTC = 'At least one field is required'
            newErrors.offlineTC = 'At least one field is required'
            isValid = false
        }

        setErrors(newErrors)
        return isValid;
    }

    const handleSubmit = async () => {
        if (!validate()) return

        setLoading(true);

        const payload = {
            key: 'producttermsandconditions',
            value: {
                tconline: onlineTC.trim(),
                tcoffline: offlineTC.trim()
            }
        }

        try {
            dispatch(saveSettingsRequest(payload))
        } catch (error) {
            console.error('Error saving terms:', error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Grid container spacing={6}>
            <Grid size={{ xs: 12, md: 4 }}>
                <TextField
                    fullWidth
                    rows={2}
                    multiline
                    label='Online T & C'
                    value={onlineTC}
                    onChange={e => setOnlineTC(e.target.value)}
                    error={!!errors.onlineTC}
                    helperText={errors.onlineTC}
                />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
                <TextField
                    fullWidth
                    rows={2}
                    multiline
                    label='Offline T & C'
                    value={offlineTC}
                    onChange={e => setOfflineTC(e.target.value)}
                    error={!!errors.offlineTC}
                    helperText={errors.offlineTC}
                />
            </Grid>
            <Grid
                size={{ xs: 12, md: 4 }}
                sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}
            >
                <Button variant='outlined' onClick={handleSubmit} disabled={loading}>
                    {loading ? <CircularProgress size={20} /> : 'Save'}
                </Button>
            </Grid>
        </Grid>
    )
}

export default TermsConditions
